import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";

export const SET_URL = "SET_URL";
export const SET_INITIAL_PAGES = "SET_INITIAL_PAGES";
export const SET_PAGE_VALUES = "SET_PAGE_VALUES";
export const SET_VALUES = "SET_VALUES";
export const SET_VISIBLE_INTERVAL = "SET_VISIBLE_INTERVAL";
export const SET_LAST_VISIBLE_PAGE = "SET_LAST_VISIBLE_PAGE";
export const CLEAN_PAGE = "CLEAN_PAGE";
export const CLEAN_DOCUMENT = "CLEAN_DOCUMENT";


var pdfStore=undefined;
var pdfPages=[]

const defaults={
    defaultWidth: 0,
    defaultHeight:0,
    firstPageDownloaded: false,
    minVisiblePage: undefined,
    maxVisiblePage: undefined,
    middleVisiblePage: undefined,
    window:1,//numFetchedPages=window*2+1
    velocity:1,
    lastVisiblePage:1,
}

const state = () => (Object.assign({
    pages: [],  
},defaults));

const getters = {
    getField,
}


// FLOW:
// pending -> downloading -> dowloaded -> rendered
export const STATE_PENDING='pending'
export const STATE_DOWNLOADING='downloading'
export const STATE_DOWNLOADED='downloaded'
export const STATE_RENDERING='rendering'
export const STATE_RENDERED='rendered'

const mutations = {
    updateField,
    [SET_URL](state, url) {
        state.url = url;
        state.firstPageDownloaded=false;
    },
    [SET_PAGE_VALUES](state, {pageIndex,values}) {
        try{
            Object.assign(state.pages[pageIndex-1],values)
        }catch {
            console.log("Exception")
        }
        
    },
    [SET_VALUES](state, values) {
        Object.assign(state,values)
    },
    [SET_INITIAL_PAGES](state, numPages) {
        state.pages.splice(0,state.pages.length)
        pdfPages.splice(0,pdfPages.length)
        for(var i=1;i<=numPages;i++){
            state.pages.splice(state.pages.length,0,{
                state:STATE_PENDING,
                numPage:i,
                width:0.,
                height:0.,
                visible:false,
            })
            pdfPages.splice(pdfPages.length,0,undefined)
        }
        
        
    },
    [CLEAN_PAGE](state, pageIndex) {
        state.pages[pageIndex-1].state='pending'
        pdfPages[pageIndex-1]=undefined;
    },
    [CLEAN_DOCUMENT](state) {
        if(pdfStore){
            pdfStore=undefined;
        }
        pdfPages.splice(0,pdfPages.length)
        state.pages.splice(0,state.pages.length)
        Object.assign(state,defaults)
    },
    [SET_LAST_VISIBLE_PAGE](state, pageIndex) {
        state.lastVisiblePage=pageIndex;
    },
    [SET_VISIBLE_INTERVAL](state) {
        var infinite=10000;
        var zero=0;
        var minPage=infinite;
        var maxPage=zero;
        for(var i=1;i<=state.pages.length;i++){
            const page=state.pages[i-1]
            if (page.visible){
                if(page.numPage > maxPage){
                    maxPage=page.numPage
                }
                if(page.numPage < minPage){
                    minPage=page.numPage
                }
            }
        }
        if(minPage==infinite) minPage=state.lastVisiblePage
        if(maxPage==zero) maxPage=state.lastVisiblePage
        var oldMiddleVisiblePage=state.middleVisiblePage
        state.minVisiblePage=minPage
        state.maxVisiblePage=maxPage
        state.middleVisiblePage=minPage+Math.ceil((maxPage-minPage)/2)
        var newVelocity=state.middleVisiblePage-oldMiddleVisiblePage
        if(newVelocity){
            state.velocity=newVelocity
        }
    },
}

const setDocumentUrl = async ({ commit,dispatch }, url) => {
    commit(CLEAN_DOCUMENT)
    commit(SET_URL, url)
    return new Promise((resolve, reject) => {
        // Using import statement in this way allows Webpack
        // to treat pdf.js as an async dependency so we can
        // avoid adding it to one of the main bundles
        import(/* webpackChunkName: 'pdfjs-dist' */'pdfjs-dist/webpack').then(function(pdfjs){ 
            let promise = pdfjs.getDocument(url).promise;
            promise.then(async (pdf)=>{
                pdfStore=pdf
                commit(SET_INITIAL_PAGES, pdf.numPages)
                await dispatch('fetchDocumentPage',1)
                await dispatch('setPageVisible',{numPage:1,visible:true})
                resolve(pdf);
            })
            
        }).catch(err => {
            reject(err);
        });
    });
}

const cleanDocument = async ({ commit}) => {
    commit(CLEAN_DOCUMENT)
    commit(SET_URL, undefined)    
}

const fetchDocumentPage = async ({ commit }, pageIndex) => {
    commit(SET_PAGE_VALUES, {pageIndex, values:{state:STATE_DOWNLOADING}}) 
    const page = await pdfStore.getPage(pageIndex)
    const {width,height} = page.getViewport({scale: 1.}); //TODO
    if(pageIndex==1){
        commit(SET_VALUES,{defaultWidth:width,defaultHeight:height,firstPageDownloaded:true})
    }
    //console.log(page)
    pdfPages[pageIndex-1]=page
    commit(SET_PAGE_VALUES, {pageIndex, values:{state:STATE_DOWNLOADED, width,height}}) 

}

const setPageValues = ({commit}, {pageIndex, values})=>
{
    commit(SET_PAGE_VALUES, {pageIndex, values:values}) 
}

const getPDFPage = ({},numPage)=>{
    return new Promise((resolve, reject) => {
        // Do something here... lets say, a http call using vue-resource
        resolve(pdfPages[numPage-1])
    }) 
}

const setPageVisible = async ({commit,state,dispatch},{numPage,visible}) =>{
    commit(SET_PAGE_VALUES, {pageIndex:numPage, values:{visible}}) 
    commit(SET_VISIBLE_INTERVAL, {}) 
    if(visible){
        commit(SET_LAST_VISIBLE_PAGE, numPage)  
    }
    for(var i=1;i<=state.pages.length;i++)
    {
        const currentPage=state.pages[i-1] 
        if(currentPage.numPage >=(state.minVisiblePage-state.window) && currentPage.numPage <=(state.maxVisiblePage+state.window)){
            if(currentPage.state==STATE_PENDING){
                await dispatch('fetchDocumentPage',i)
            } 
        }
        else{
            await dispatch('cleanPage',i)
        }
    }
}

const cleanPage=({commit,state,dispatch},numPage)=>{
    if(numPage<=state.pages.length){
        const currentPage=state.pages[numPage-1]
        if(currentPage.state!=STATE_PENDING){
            if(pdfPages[numPage-1]){
                //pdfPages[numPage-1]._destroy() 
            }
            commit(CLEAN_PAGE,numPage)
        } 
    }else{
        console.log(`trying to clean page ${numPage} with length ${state.pages.length}`)
    }
    

}

const actions = {
    setDocumentUrl,
    fetchDocumentPage,
    setPageValues,
    getPDFPage,
    setPageVisible,
    cleanPage,
    cleanDocument,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}